const Noop = ({ children }) => children;

export default Noop;
